<div class="card">
  <div class="card-body" style="padding: 5px;">
    <kendo-tabstrip (tabSelect)="onTabSelect($event)">
      <kendo-tabstrip-tab [title]="'Filter List'" [selected]="isRuleList">
        <ng-template kendoTabContent>
              <div>
                  <kendo-grid
                  [data]="gridView"
                  [pageSize]="rulePageSize"
                  [skip]="state.skip"
                  [sortable]="true"
                  [pageable]="true"
                  [filterable]="true"
                  (pageChange)="pageChange($event)"
                  (valueChange)="sliderChange($event)"
                  (edit)="editFilter($event)" (remove)="removeFilter($event)"
                  >
                  <ng-template kendoGridToolbarTemplate let-dataItem>
                    <button type="button" class="k-button" kendoGridExcelCommand ><i class="mdi mdi-export" aria-hidden="true"></i>Export to Excel</button>
                    <button type="button" kendoGridRemoveCommand class="k-button" (click)="onMassDelete()" ><i class="mdi mdi-delete" aria-hidden="true"></i>Delete</button>
                    <button  type="button" (click)="onRefresh()" class="btn-save-rule" style="height: 28px;margin-top: 0px;"><i class="mdi mdi-refresh " aria-hidden="true"></i>Refresh</button>
                    <button type="button" (click)="addFilter()" class="btn-save-rule" style="height: 28px;margin-top: 0px;"><i class="mdi mdi-plus " aria-hidden="true"></i>Add</button>
                  </ng-template>
                  <kendo-grid-checkbox-column width="60" title="">
                    <ng-template kendoGridCellTemplate let-dataItem>
                     <input type="checkbox" 
                     name="checked"
                     [(ngModel)]="dataItem.IsChecked"
                     (change)="selectRuleList(dataItem)" 
                     [checked]="listRuleSelected"/>
                    </ng-template>
                  </kendo-grid-checkbox-column>
                  <kendo-grid-column field="Id" title="ID" width="60" [filterable]="false">
                  </kendo-grid-column>
                  <kendo-grid-column field="FilterName" title="FilterName">
                  </kendo-grid-column>
                  <kendo-grid-command-column title="" width="135">
                    <ng-template kendoGridCellTemplate>
                        <button kendoGridEditCommand [primary]="true">Edit</button>
                    </ng-template>
                  </kendo-grid-command-column>
                  <kendo-grid-excel fileName="ProductionRuleList.xlsx"></kendo-grid-excel>
                </kendo-grid>
              </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab [title]="'Filter'" [selected]="isRuleForm">
        <ng-template kendoTabContent>
          <div class="card">
            <div class="row" style="margin: 1px;">
              <div style="margin:5px;">
                <label style="margin-right: 5px;font-weight: 600;font-size: 12px;">Filter Name:</label>
                <input type="text" [(ngModel)]="filter.FilterName" style="border: 1px solid #d2d0d0;border-radius: 5px;height: 31px;" />
              </div>
              <div style="margin:5px;">
                <label style="margin-right: 5px;font-weight: 600;font-size: 12px;">Priority:</label>
                <input type="text" [(ngModel)]="filter.Priority" style="border: 1px solid #d2d0d0;border-radius: 5px;height: 31px;"/>
              </div>
            </div>
            <div class="card-body" style="padding: 20px;border: 5px solid #153e71;border-radius: 10px;">
              <div class="row" style="margin-bottom: -8px;">
                  <app-ct-query-builder (onfilter)="onfetchMore($event)" (onSearch)="onSearch($event)" (resetPage)="resetPage()"  class="margin30" [data]="query" [config]="config">
                  </app-ct-query-builder>
              </div>
            </div>
            <div style="margin-right: 15px;">
              <button kendoButton (click)="saveFilter(query)" class="btn-info.btn-outline:hover btn-save-rule"> <i class="fa fa-save"></i> Save</button>
            </div>
          </div>
          <hr>
          <div>
            <app-rule-properties [ruleLeft]="ruleLeft" [ruleRight]="ruleRight" (appliedSaveEvent)="onSaveAppliedRule($event)" (propertiesSaveEvent)="onSaveProperties($event)"></app-rule-properties>
          </div>
          
        </ng-template>
      </kendo-tabstrip-tab>
    </kendo-tabstrip>
  </div>
</div>


